import { Button, Dialog, DialogContent, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const ResentDialog = (props) => {
  const theme = useTheme();
  const { showResentDialog, onResentClick, resentMessage } = props;
  return (
    <Dialog open={showResentDialog} className="info-dialog">
      <DialogContent sx={{ padding: "40px" }}>
        <Box mt={2}>
          <Typography
            variant="text4"
            sx={{ color: theme.palette.common.textGrey2, fontFamily: "Lato-Regular" }}
          >
            {resentMessage || "A verification code has been resent."}
          </Typography>
        </Box>
        <Box mt={5} mb={1}>
          <Button
            variant="large"
            onClick={onResentClick}
            sx={{ minWidth: { xs: "150px", sm: "150px", md: undefined } }}
          >
            DONE
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ResentDialog;
